export function normaliseReferralCode(input: string | null | undefined): string | null {
  if (typeof input !== "string") {
    return null;
  }
  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }
  const withoutPrefixes = trimmed.replace(/^ref=/i, "").replace(/^@/, "");
  const normalized = withoutPrefixes.trim().toLowerCase();
  return normalized.length > 0 ? normalized : null;
}

export function formatReferralCode(input: string | null | undefined): string | null {
  const normalized = normaliseReferralCode(input);
  if (normalized) {
    return normalized;
  }
  if (typeof input === "string") {
    const trimmed = input.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  return null;
}
